import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Passwort wurde geändert. Bitte anmelden.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-md">
        <Logo className="mb-8 justify-center" />
        <div className="bg-white border border-border rounded-lg shadow-sm p-8">
          <h1 className="text-2xl font-serif mb-6">Neues Passwort</h1>
          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <div className="space-y-2">
              <Label htmlFor="pw">Neues Passwort</Label>
              <Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={6} data-testid="reset-password" />
            </div>
            <Button type="submit" className="w-full" disabled={busy || !token} data-testid="reset-submit-button">
              {busy ? "Wird gespeichert…" : "Passwort ändern"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
